import React from "react";
import InitialPropsContext from "../lib/models/initialPropsContext";
import PageNotFoundError from "../lib/pageNotFoundError";
import AdvancedArticlePage from "../components/article/AdvancedArticlePage";
import { ApiResult } from "../lib/CmsApi";
import PageProps from "../lib/models/pageProps";
import { NachhaltigkeitArticle } from "../lib/CmsApi";
import NachhaltigkeitPage from "../components/nachhaltigkeit/NachhaltigkeitPage";

export default function Page(props: NachhaltigkeitArticle) {
  return (
    <NachhaltigkeitPage
      sections={props.sections}
      url={`nachhaltigkeit/${props.slug}`}
      breadCrumpPath={[
        {
          title: props.title,
          route: "nachhaltigkeit",
          params: { segment: props.slug }
        }
      ]}
      {...props}
    />
  );
}

Page.getInitialProps = async ({
  api,
  query,
  asPath
}: InitialPropsContext): PageProps<NachhaltigkeitArticle> => {
  const { slug } = query;

  const page = await api
    .loadNachhaltigkeitArticleBySlug(slug as string)
    .catch(() => {
      throw new PageNotFoundError();
    });

  const pageContents = await api
    .listNachhaltigkeitArticles()
    .catch(() => ({ total: 0, items: [] }));

  const breadCrumpPath = [
    {
      route: "/nachhaltigkeit",
      title: "Nachhaltigkeit",
      params: {
        segment: `nachhaltigkeit/${page.slug}`
      }
    }
  ];

  const pageProps = {
    ...page,
    url: asPath,
    breadCrumpPath,
    pageContents
  };

  return {
    ...pageProps
  };
};
